// extracted by mini-css-extract-plugin
module.exports = {"container":"PageNotFound_container_2g59O","title":"PageNotFound_title_3R6-m","subtitle":"PageNotFound_subtitle_3OQau"};